import ReactGA from 'react-ga4';
import { Result } from '@hitiq/generic';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { Player, PlayerBackend } from './player.interfaces';
// import { translator as translation } from '../../../../translations/translation.config';

export const deletePlayerThunk = createAsyncThunk(
  'player/deletePlayer',
  async (
    payload: {
      persistence: any;
      dataStoreModel: any;
    },
    thunkAPI,
  ): Promise<any> => {
    const { persistence, dataStoreModel } = payload;
    return persistence
      .delete(dataStoreModel)
      .then((response: Result<PlayerBackend>) => {
        // WARNING: don't use response in redux since onDelete will do this.
        ReactGA.event({
          category: 'Player',
          action: 'Delete',
        });
        return true;
      })
      .catch((error: any) => {
        return thunkAPI.rejectWithValue({
          heading: 'unableToDeletePlayer', // translation.translateText('settings:unableToDeletePlayer'),
          message: error.toString(),
          severity: 'error',
          id: uuidv4(),
        });
      });
  },
);
